import { TopBar } from '../../top-bar/TopBar';
import { PublicOptions } from '../../../data/publicOptions';
import { Footer } from '../../footer/Footer';
import './Schedule.css';
import { useEffect, useState } from 'react';

const API_BASE = 'https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion';

export const Schedule = () => {
  const [schedule, setSchedule] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE}`)
      .then((res) => res.json())
      .then((data) => {
        setSchedule(data.schedule);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <>
      <TopBar options={PublicOptions} />
      <div className="content">
        <section className="snn-page-section">
          <h2 className="snn-title">{schedule?.title || 'Program'}</h2>

          {loading && <p>Loading schedule...</p>}

          {!loading && !schedule && (
            <p style={{ textAlign: 'center', color: '#94a3b8', padding: '40px 0' }}>
              The program will be available soon.
            </p>
          )}

          {!loading && schedule && (
            <>
              {schedule.download_links && schedule.download_links.length > 0 && (
                <div className="schedule-links-wrapper">
                  {schedule.download_links.map((link, i) => (
                    <p key={i}>
                      <a className="email-link" href={link.url} target="_blank" rel="noreferrer">
                        <span className="material-symbols-outlined">download</span> {link.label}
                      </a>
                    </p>
                  ))}
                </div>
              )}

              <div className="schedule-grid">
                {schedule.days &&
                  schedule.days.map((day, di) => (
                    <div key={di} className="schedule-grid-day">
                      <h3 className="schedule-grid-day-title">{day.dayLabel}</h3>
                      <h2 className="schedule-grid-day-date">{day.date}</h2>
                      {day.events &&
                        day.events.map((ev, ei) => (
                          <div key={ei} className="schedule-grid-event">
                            <hr />
                            <p className="schedule-grid-event-hour">{ev.time}</p>
                            <p>
                              {ev.code && (
                                <>
                                  <small className="schedule-grid-event-location">{ev.code}</small>
                                  <br />
                                </>
                              )}
                              {ev.title}
                              {ev.speaker && (
                                <>
                                  <br />
                                  {ev.speaker}
                                </>
                              )}
                              {ev.location && (
                                <>
                                  <br />
                                  <small className="schedule-grid-event-location">
                                    {ev.location}
                                  </small>
                                </>
                              )}
                            </p>
                          </div>
                        ))}
                    </div>
                  ))}
              </div>
            </>
          )}
        </section>
      </div>
      <Footer />
    </>
  );
};
